import { useEffect, type ReactNode } from 'react';
import { QueryProvider } from '@app/providers/QueryProvider';
import { setUnauthorizedHandler } from '@shared/api/http-client';
import { clearAuthSession } from '@features/auth/model/auth.store';
import { useRestoreSession } from '@features/auth/model/use-auth';

/**
 * Connects the transport layer to the auth store. Doing it here, rather than at
 * module scope inside the client, keeps `http-client.ts` free of any import of
 * the store — which would otherwise be a cycle, since the store's API calls go
 * back through the client.
 */
function AuthBridge({ children }: { children: ReactNode }) {
  useEffect(() => {
    setUnauthorizedHandler(clearAuthSession);
  }, []);

  useRestoreSession();

  return <>{children}</>;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <AuthBridge>{children}</AuthBridge>
    </QueryProvider>
  );
}
